<template>
  <div style="border-bottom: 1px solid black;">
    <el-row>
      <el-col :span="24">
        <div>涂料名称：{{this.tzCaseRecord.tl_name}}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div>涂料批号：{{this.tzCaseRecord.tl_batch}}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div>m/分：{{this.tzCaseRecord.speed}}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <div>烘烤#1：{{this.tzCaseRecord.hk1}}</div>
      </el-col>
      <el-col :span="8">
        <div>烘烤#2：{{this.tzCaseRecord.hk2}}</div>
      </el-col>
      <el-col :span="8">
        <div>烘烤#3：{{this.tzCaseRecord.hk3}}</div>
      </el-col>
    </el-row>
  </div>
  <div style="border-bottom: 1px solid black;">
    <el-row>
      <el-col :span="24" class="text-center">
        <div>补正者</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div></div>
      </el-col>
      <el-col :span="4">
        <div>#1:</div>
      </el-col>
      <el-col :span="4">
        <div>#2:</div>
      </el-col>
      <el-col :span="4">
        <div>#3:</div>
      </el-col>
      <el-col :span="4">
        <div>#4:</div>
      </el-col>
      <el-col :span="4">
        <div>#5:</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div></div>
      </el-col>
      <el-col :span="4">
        <div>{{this.tzCaseRecord.user1}}</div>
      </el-col>
      <el-col :span="4">
        <div>{{this.tzCaseRecord.user2}}</div>
      </el-col>
      <el-col :span="4">
        <div>{{this.tzCaseRecord.user3}}</div>
      </el-col>
      <el-col :span="4">
        <div>{{this.tzCaseRecord.user4}}</div>
      </el-col>
      <el-col :span="4">
        <div>{{this.tzCaseRecord.user5}}</div>
      </el-col>
    </el-row>
  </div>
  <div style="border-bottom: 1px solid black;">
    <el-row>
      <el-col :span="24" class="text-center">
        <div>电压(-KV)</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div></div>
      </el-col>
      <el-col :span="5">
        <div>#1:</div>
      </el-col>
      <el-col :span="5">
        <div>#2:</div>
      </el-col>
      <el-col :span="5">
        <div>#3:</div>
      </el-col>
      <el-col :span="5">
        <div>#4:</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="text-align: center;">
        <div>正</div>
      </el-col>
      <el-col :span="5">
        <div>{{this.tzCaseRecord.kv1}}</div>
      </el-col>
      <el-col :span="5">
        <div>{{this.tzCaseRecord.kv2}}</div>
      </el-col>
      <el-col :span="5">
        <div>{{this.tzCaseRecord.kv3}}</div>
      </el-col>
      <el-col :span="5">
        <div>{{this.tzCaseRecord.kv4}}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="text-align: center;">
        <div>反</div>
      </el-col>
      <el-col :span="5">
        <div>{{this.tzCaseRecord.kv5}}</div>
      </el-col>
      <el-col :span="5">
        <div>{{this.tzCaseRecord.kv6}}</div>
      </el-col>
      <el-col :span="5">
        <div>{{this.tzCaseRecord.kv7}}</div>
      </el-col>
      <el-col :span="5">
        <div>{{this.tzCaseRecord.kv8}}</div>
      </el-col>
    </el-row>
  </div>
  <div>
    <el-row>
      <el-col :span="1">
        <div></div>
      </el-col>
      <el-col :span="11">
        <div>室温：{{this.tzCaseRecord.t1}}</div>
      </el-col>
      <el-col :span="11">
        <div>湿度：{{this.tzCaseRecord.t2}}</div>
      </el-col>
    </el-row>
  </div>
<!--  <div class="detail" v-show="tzCaseRecord.pictures_pics_ids !== ''">-->
<!--    <div class="nowrapDiv">-->
<!--      <div class="fontBold">照片</div>-->
<!--    </div>-->
<!--    <el-image v-for="imageUrl in tzCaseRecord.pictures_pics_list" :preview-src-list="tzReceiveRecord.pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>-->
<!--  </div>-->
</template>

<script>
export default {
  name: "BusTzCaseRecord",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return{
      tzCaseRecord:{}
    }
  },
  methods:{
    async getTzCaseRecord(){
      let {data: res} = await this.$axios.post('bus/tz/getTzCaseRecord',this.parentData.id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.tzCaseRecord = res.data
        console.log(this.tzCaseRecord)
      }
    }
  },
  created() {
    this.getTzCaseRecord()
  }
}
</script>

<style scoped>
.text-center {
  text-align: center; /* 水平居中 */
  font-size: 16px; /* 字体大小为16px */
  font-weight: bold; /* 字体加粗 */
}

.nowrapDiv {
  display: flex;
  flex-wrap: nowrap;
}

.fontBold {
  font-weight: bold;
}

.imageStyle {
  width: 87px;
  height: 87px;
  margin-right: 5px
}
</style>